import PropTypes from 'prop-types';
import React from 'react';
import FooterButton from './FooterButton';

var DashboardTesTeachFooter = function DashboardTesTeachFooter(_ref) {
  var lessonToken = _ref.lessonToken;
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card__footer"
  }, /*#__PURE__*/React.createElement("span", {
    className: "dashboard-card__footer__left-side"
  }, /*#__PURE__*/React.createElement(FooterButton, {
    primary: true,
    text: "Share"
  }), /*#__PURE__*/React.createElement(FooterButton, {
    text: "View/Edit"
  })), /*#__PURE__*/React.createElement("span", {
    className: "dashboard-card__footer__right-side"
  }, /*#__PURE__*/React.createElement(FooterButton, {
    text: "Delete"
  }), /*#__PURE__*/React.createElement(FooterButton, {
    text: "Copy"
  })));
};

DashboardTesTeachFooter.displayName = "DashboardTesTeachFooter";
DashboardTesTeachFooter.propTypes = {
  lessonToken: PropTypes.string.isRequired
};
export default DashboardTesTeachFooter;